import { DateTime } from "luxon";
import i18n from "./i18next";
export const formatDate = (date: string) => {
  const selectedLng = i18n?.resolvedLanguage || "pl";
  return DateTime.fromISO(date).setLocale(selectedLng).toFormat("MMM d, yyyy");
};

export const formatDateWithTime = (date: string, options?: { excludeSeconds: boolean }) => {
  const selectedLng = i18n?.resolvedLanguage || "pl";
  return (
    DateTime.fromISO(date)
      .setLocale(selectedLng)
      .toFormat(`MMM d, yyyy HH:mm${options?.excludeSeconds ? "" : ":ss"}`) + " Europe/Warsaw"
  );
};

export const formatSimpleDate = (date: string) => {
  const selectedLng = i18n?.resolvedLanguage || "pl";
  return DateTime.fromISO(date).setLocale(selectedLng).toFormat("MMM d");
};

export const today = DateTime.now()
  .setZone("system")
  .setZone("UTC", { keepLocalTime: true })
  .toISO();
